import { useConfigValueByCurrentDevice } from '../useConfigValueByCurrentDevice'
import { config } from '../../components/Init/Init'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import l10n from '../../components/i18n/I18N'

export const useRoutesIntercepting = () => {
  const enableBigWinsFeed = useConfigValueByCurrentDevice(config.enableBigWinsFeed)
  const navigate = useNavigate()

  const bigWinsMatch = location.pathname.indexOf('/casino/big-win') >= 0

  useEffect(() => {
    if (!enableBigWinsFeed && bigWinsMatch) {
      navigate(`/${l10n.locale}/casino/lobby`)
    }
  }, [bigWinsMatch])
}
